<template>
  <div class="index">
    <div class="content1">
      <div class="content1_box">
        <div class="content1_box_left">
          <div class="content1_box_left_li"></div>
          <div class="content1_box_left_li2"></div>
          <div class="content1_box_left_li3"></div>
        </div>
        <div class="content1_box_right">
          <div class="content1_box_right_head">
            行业资讯
            <p class="more" @click="tonew">更多</p>
          </div>
          <p
            class="content1_box_right_li"
            v-for="(item, index) in newsArr"
            :key="index"
            @click="tonews(item)"
          >
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="content2">
      <div class="content2_head" @click="mouseleavefuc"></div>
      <div class="content2_box">
        <div class="content2_box_left" @click="mouseenterfuc"></div>
        <div class="content2_box_right">
          <div class="swiper-container swiper-no-swiping"
          @mouseenter="mouseenterfuc"
          @mouseleave="mouseleavefuc">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in fangArr"
                :key="index"
                @click="goan(item, 2)"
              >
                <div class="content2_box_right_li">
                  {{ item.title }}
                  <span>主治：{{ item.indications }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content3">
      <div class="content3_left">
        <img src="../assets/image/more@2x.png" alt="" @click="toan" />
      </div>
      <div class="content3_center">
        <div
          class="swiper-container2 swiper-no-swiping"
          @mouseenter="mouseenterfuc2"
          @mouseleave="mouseleavefuc2"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(citem, cindex) in anArr"
              :key="cindex"
              @click="goan(citem, 1)"
            >
              <img
                class="content3_center_li"
                :src="require('../assets/image/banner' + (cindex + 5) + '.png')"
                alt=""
                srcset=""
              />
              <p class="content3_center_li_p">{{citem.title}}</p>
            </div>
            <div
              class="swiper-slide"
              v-for="(item, index) in anArr"
              :key="index"
              @click="goan(item, 1)"
            >
              <img
                class="content3_center_li"
                :src="require('../assets/image/banner' + (index + 5) + '.png')"
                alt=""
                srcset=""
              />
              <p class="content3_center_li_p">{{ item.title }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="content3_right">
        <img src="../assets/image/box3_right.png" alt="" srcset="">
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      newsArr: [],
      changArr: [],
      mySwiper: null,
      mySwiper2: null,
      anArr: [],
      fangArr: [],
    };
  },
  created() {
    this.getnews();
    this.get_chang();
    this.get_an();
    this.get_fang();
  },
  mounted() {},
  methods: {
    getnews() {
      $.ajax({
        url: "/static/json/news/list.json",
        type: "GET",
        success: (res) => {
          this.newsArr = res.slice(0, 8);
        },
      });
    },
    get_an() {
      let datas = {
        size: 4,
      };
      this.$axios
        .get("cases/hot_recommend", {
          params: datas,
        })
        .then((res) => {
          if (res.status == 200 && res.data.status_code == 200) {
            // console.log(res);
            this.anArr = res.data.data;
            this.swiper_init2(".swiper-container2");
          }
        });
    },
    get_fang() {
      let that = this;
      let datas = {
        size: 10,
      };
      that.$axios
        .get("fang/hot_recommend", {
          params: datas,
        })
        .then((res) => {
          if (res.status == 200 && res.data.status_code == 200) {
            // console.log(res);
            that.fangArr = res.data.data;
            this.swiper_init(".swiper-container");
          }
        });
    },
    get_chang() {
      this.$axios.get("zk_fang/common").then((res) => {
        if (res.data.status_code == 200) {
          // console.log(res);
          this.changArr = res.data.data;
        }
      });
    },
    swiper_init(obj) {
      var that = this;
      that.$nextTick(function () {
        this.mySwiper = new Swiper(obj, {
          direction: "vertical",
          speed: 2000, //设置过度时间
          loop: true, //允许从第一张到最后一张，或者从最后一张到第一张  循环属性
          autoplay: {
            delay: 1,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          slidesPerView: 6, // 设置显示三张
          spaceBetween: 0,
          allowTouchMove: true,
        });
      });
    },
    mouseenterfuc() {
      this.mySwiper.autoplay.stop();
    },
    mouseleavefuc() {
      this.mySwiper.autoplay.start();
    },
    mouseenterfuc2() {
      this.mySwiper2.autoplay.stop();
    },
    mouseleavefuc2() {
      this.mySwiper2.autoplay.start();
    },
    swiper_init2(obj) {
      var that = this;
      that.$nextTick(function () {
        this.mySwiper2 = new Swiper(obj, {
          speed: 2000, //设置过度时间
          loop: true, //允许从第一张到最后一张，或者从最后一张到第一张  循环属性
          autoplay: {
            delay: 1,
            stopOnLastSlide: false,
            autoplayDisableOnInteraction: false,
          },
          slidesPerView: 5, // 设置显示三张
          spaceBetween: 0,
          allowTouchMove: false,
        });
      });
    },
    goan(item, num) {
      if (num == 1) {
        this.$router.push({
          path: "/anDetail",
          query: {
            name: item.title,
            t: 4,
            cid: item.case_id,
          },
        });
      } else {
        this.$router.push({
          path: "/fangDetail",
          query: {
            name: item.title,
            t: 4,
            cid: item.fang_id,
          },
        });
      }
    },
    tonews(item) {
      console.log(item);
      this.$router.push({
        path: "/details",
        query: {
          did: item.id,
          title: item.title,
          time: item.time,
        },
      });
    },
    tonew() {
      this.$router.push({
        path: "/news",
      });
    },
    tofang() {
      this.$router.push({
        path: "/fang",
      });
    },
    toan() {
      this.$router.push({
        path: "/an",
      });
    },
    goanlist_yj(iname, num) {
      this.$router.push({
        path: "/fangList",
        query: {
          name: iname,
          t: num,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.index {
  .content1 {
    width: 100%;
    background: #f6f6f6;
    .content1_box {
      width: 1200px;
      height: 555px;
      margin: 0 auto;
      padding: 52px 0px 42px 0px;
      display: flex;
      .content1_box_left {
        width: 712px;
        height: 100%;
        .content1_box_left_li {
          width: 100%;
          height: 357px;
          background: url("../assets/image/banner1.png") no-repeat center center;
          background-size: cover;
          margin-bottom: 30px;
        }
        .content1_box_left_li2,
        .content1_box_left_li3 {
          width: 340px;
          height: 170px;
          display: inline-block;
          background: url("../assets/image/banner2.png") no-repeat center center;
          background-size: cover;
        }
        .content1_box_left_li3 {
          background: url("../assets/image/banner3.png") no-repeat center center;
          background-size: cover;
          margin-left: 32px;
        }
      }
      .content1_box_right {
        width: 454px;
        height: 100%;
        box-sizing: border-box;
        padding: 20px;
        background: #ffffff;
        box-shadow: -8px -2px 10px 1px rgba(46, 86, 142, 0.14);
        margin-left: 33px;
        .content1_box_right_head {
          width: 100%;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 24px;
          margin-bottom: 52px;
          &::before {
            display: inline-block;
            content: "";
            width: 24px;
            height: 24px;
            background: url("../assets/image/TCM_icon@2x.png") no-repeat center
              center;
            background-size: cover;
          }
          .more {
            color: #3a4b7b;
            border: 1px solid #3a4b7b;
            float: right;
            font-size: 16px;
            padding: 6px 8px;
            cursor: pointer;
          }
        }
        .content1_box_right_li {
          height: 51px;
          width: 100%;
          box-sizing: border-box;
          padding: 0px 13px;
          font-family: SourceHanSansCN-Bold;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
    }
  }
  .content2 {
    width: 1200px;
    margin: 0 auto;
    margin-top: 22px;
    .content2_head {
      width: 148px;
      height: 56px;
      background: url("../assets/image/fj_little@2x.png") no-repeat center
        center;
      background-size: cover;
      margin: 0 auto;
      margin-bottom: 54px;
    }
    .content2_box {
      display: flex;
    }
    .content2_box_left {
      width: 580px;
      height: 386px;
      background: url("../assets/image/banner4.png") no-repeat center center;
      background-size: cover;
      margin-right: 38px;
    }
    .content2_box_right {
      width: 580px;
      height: 386px;
      // overflow: hidden;
      .swiper-container {
        width: 100%;
        height: 100%;
      }
      .content2_box_right_li {
        width: 100%;
        height: 52px;
        box-sizing: border-box;
        border: 1px solid #d1ae87;
        margin-bottom: 15px;
        line-height: 52px;
        padding: 0px 40px;
        font-weight: bolder;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        background: linear-gradient(
          180deg,
          rgba(191, 183, 170, 0.28),
          rgba(221, 180, 115, 0)
        );
        span {
          margin-left: 60px;
        }
      }
    }
  }
  .content3 {
    width: 100%;
    height: 313px;
    display: flex;
    margin-top: 87px;
    .content3_left {
      width: 438px;
      height: 313px;
      background: url("../assets/image/image_9@2x.png") no-repeat center center;
      background-size: cover;
      position: relative;
      img {
        width: 28px;
        height: 255px;
        position: absolute;
        right: 13px;
        top: 36px;
        cursor: pointer;
      }
    }
    .content3_center {
      width: calc(100% - 798px);
      height: 100%;
      // display: flex;
      overflow: hidden;
      .swiper-slide {
        display: inline-block;
        margin: 0px 20px;
        position: relative;
      }
      .content3_center_li {
        width: 250px;
        height: 167px;
        margin: 77px 20px 0px;
      }
      .content3_center_li_p {
        width: 100%;
        height: 167px;
        color: #fff;
        line-height: 167px;
        text-align: center;
        position: absolute;
        z-index: 2;
        top: 77px;
        left: 20px;
      }
    }
    .content3_right {
      width: 360px;
      height: 313px;
      background: #ffffff;
      box-shadow: -8px -2px 10px 1px rgba(46, 86, 142, 0.14);
      padding: 16px 20px 20px 70px;
      box-sizing: border-box;
      img{
        width: 270px;
        height: 277px;
      }
    }
  }
}
</style>